import { Header } from "@components/Header";
import { FilterDrawerProvider } from "@/hooks/useFilterDrawer";
import { Outlet } from "react-router-dom";

/**
 * Invisible 1px fixed element that anchors the iOS WebKit viewport,
 * preventing dynamic horizontal/vertical expansion after content loads.
 */
const ViewportSentinel = () => (
  <div
    aria-hidden="true"
    style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      height: 1,
      pointerEvents: "none",
      opacity: 0,
      zIndex: -1,
    }}
  />
);

export const Layout = () => {
  return (
    <FilterDrawerProvider>
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <Header />
      <main id="main-content">
        <Outlet />
      </main>
      <ViewportSentinel />
    </FilterDrawerProvider>
  );
};
